import React, { useCallback, useEffect } from "react";
import cls from "./style.module.scss";
import useStyles from "isomorphic-style-loader/useStyles";
import { useSelector } from "react-redux";
import { useMemo } from "react";
import { useState } from "react";
import { IMAGE_GEEKO_LTD } from "../../../../../../../constants";
import { Iconfont } from "../../../../../../components/icon/iconfont";
import { Link, useHistory } from "react-router-dom";
import { useIntl, FormattedMessage } from "react-intl";
import NormalConfigConfirm from "../../../../../../../client/components/alert/config-confirm";


const GuestUser = props =>{
    const Intl = useIntl();
    const history = useHistory();

    const handleClick = () =>{
        NormalConfigConfirm({
            title:{
                text:Intl.formatMessage({ id: "guest_user", defaultMessage: "Guest User" })
            },
            message:{
                text:Intl.formatMessage({ id: "temporay_account_set_password", defaultMessage: "This is your temporay account. Set up password to register to get more discount!" }),
            },
            btn1:{
                text:Intl.formatMessage({ id: "set_password", defaultMessage: "Set password" }),
                clickHandle:()=>{
                    history.push("/user/set-password");
                }
            },
            btn2:{
                clickHandle:() =>{
                    // 单删取消点击
                    if(window.GeekoSensors){
                        window.GeekoSensors.Track('WishlistButtonClick', {
                            page_sort:"wish list",
                            page_type: "收藏夹页",
                            button_pv:"cancel",
                            is_success:true
                        })
                    }
                }
            }
        });
    }
    
    return <div className={cls.GuestUser}>
        <span className={cls.Font}><FormattedMessage id="guest_user" defaultMessage="Guest User" /></span>
        <Iconfont className={cls.Icon} onClick={handleClick}>&#xe718;</Iconfont>
    </div>
}

const HeaderIconMessage = props =>{
    const { customer, isLogin, isVipUser, checkoutLoginStatus, onlyCheckoutLoginHandle } = props;
    const global = useSelector(state =>state.global);
    const { config } = global;
    const [headerImage, setHeaderImage] = useState(`https://s3-us-west-2.amazonaws.com/image.chic-fusion.com/icon/${customer?.id}?icon=${Date.now()}`);
    const Intl = useIntl();

    useEffect(() =>{
        if(customer?.id){
            setHeaderImage(`https://s3-us-west-2.amazonaws.com/image.chic-fusion.com/icon/${customer?.id}?icon=${Date.now()}`);
        }
    }, [customer]);

    const baseHeaderUrl = useMemo(() =>{
        let imageUrl;
        if (config?.shortName === 'chicme') {
            imageUrl = `${IMAGE_GEEKO_LTD}/chicme/20210813/icon.png`;
        } else if (config?.shortName === 'ivrose') {
            imageUrl = `${IMAGE_GEEKO_LTD}/chicme/20210813/iv.png`;
        } else {
            imageUrl = `${IMAGE_GEEKO_LTD}/chicme/20210813/bq.png`;
        }

        return imageUrl;
    }, [config?.shortName]);

    const disposeName = useMemo(() =>{
        if(isLogin){
            if(customer?.nickname){
                return customer.nickname;
            }else if(customer?.name?.firstName || customer?.name?.lastName){
                return `${customer?.name?.firstName || ""} ${customer?.name?.lastName || ""}`
            }else if(customer?.email){
                return customer.email
            }else if(customer?.phoneNumber){
                return customer.phoneNumber;
            }
        }else{
            return Intl.formatMessage({id:"login_or_register", defaultMessage:"Sign In/Register"});
        }
    }, [isLogin, customer]);

    const bioHandle = useCallback(() =>{
        checkoutLoginStatus("/user/set-bio", 1);
    }, [isLogin]);

    return <div className={cls.HeaderIcon}>
        <div className={cls.IconContainer}>
            <span className={cls.UserIcon} 
                style={{backgroundImage: `url(${headerImage}), url(${baseHeaderUrl})`}} 
                onClick={() =>checkoutLoginStatus("/user/edit-profile", 1)}
            >
                {
                    isLogin && <span className={cls.IconEdit}>
                        <Iconfont>&#xe6ce;</Iconfont>
                    </span>
                }
            </span>
        </div>

        <div className={cls.EditContainer}>
            <div className={cls.NameItem}>
                <span className={`${cls.UserName} ${!isVipUser?cls.NoVipClass:""}`} onClick={onlyCheckoutLoginHandle}>{disposeName}</span>
                {
                    isVipUser && <Iconfont className={cls.VipIcon}>&#xe70e;</Iconfont>
                }
            </div>

            <div className={cls.BioItem} onClick={bioHandle}>
                <span className={cls.Content}>{customer?.bio || Intl.formatMessage({id:"introduce_to_others", defaultMessage:"Introduce yourself to others"})}</span>
                <Iconfont className={cls.Icon}>&#xe6ce;</Iconfont>
            </div>
        </div>
    </div>
}

export default props =>{
    useStyles(cls);
    const { customer, isLogin, isVipUser, checkoutLoginStatus, showVip, onlyCheckoutLoginHandle, showNewIcon } = props;
    const global = useSelector(state=>state.global);
    const { config } = global;

    return <div className={cls.UserInfoMessage}>
        {
            customer?.temporary && <GuestUser />
        }
        <div className={`${cls.HeaderIconCon} ${!isVipUser?cls.NoVipClass:""}`}>
            <div className={`${cls.Container} ${!isVipUser?cls.NoVipClass:""}`} style={customer?.vipUser.backgroundImageURL && showVip ? {backgroundImage: `url(${customer.vipUser.backgroundImageURL})`} : {}}>
                <HeaderIconMessage customer={customer} isLogin={isLogin} isVipUser={isVipUser} checkoutLoginStatus={checkoutLoginStatus} onlyCheckoutLoginHandle={onlyCheckoutLoginHandle} />

                {
                    isVipUser && <Link className={cls.VipHeaderMessage} to={`/user/vip`}>
                        <Iconfont className={cls.Icon1}>&#xe70e;</Iconfont>
                        <span className={cls.VipLevel}>{config?.name} VIP V{customer?.vipUser?.level}</span>
                        {/* /context/show-vip */}
                        {
                            showNewIcon && <span className={cls.VipDot}></span>
                        }
                        <Iconfont className={cls.Icon2}>&#xe694;</Iconfont>
                    </Link>
                }
                
            </div>
        </div>
        
    </div>
}